import React from 'react';
import PropTypes from 'prop-types';
import Error from './Error';
import Input from './Input';
import styled from 'styled-components';

const FormField = ({
  input,
  meta,
  component: Component,
  isAboveError,
  wrapperClassName,
  onBlur: customOnBlur,
  ...props
}) => {
  const {
    touched,
    error
  } = meta || {};

  const handleBlur = (event) => {
    if (input?.onBlur) {
      input.onBlur(event);
    }
    if (customOnBlur) {
      customOnBlur(event);
    }
  };

  return <FormInputWrap className={wrapperClassName}>
      <Component {...props} {...input} onBlur={handleBlur} />
      {touched && error && <Error error={error} top={isAboveError} />}
    </FormInputWrap>;
};

FormField.propTypes = {
  input: PropTypes.shape(),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  component: PropTypes.elementType,
  isAboveError: PropTypes.bool,
  wrapperClassName: PropTypes.string
};
FormField.defaultProps = {
  input: null,
  meta: null,
  component: Input,
  isAboveError: false,
  wrapperClassName: ''
};
export const renderComponentField = component => {
  return props => <FormField component={component} {...props} />;
};
export default FormField; // region STYLES

const FormInputWrap = styled.div`
  width: 100%;
`; // endregion
